module.exports = __webpack_public_path__ + "img/download-01.323fd80f.svg";